<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
    <v-row dense>
                  <v-col cols="12" md="8" >

                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field  v-show="$route.params.uuid == 'init'"
                      label="帳號"
                      type="text"
                      :rules="nameRules"
                      dense
                      counter
                      maxlength="20"
                      class="font-weight-normal"
                      v-model="member.account"
                      :error-messages="txtAccountExists"
                      v-on:change="checkAccount"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field  v-show="$route.params.uuid != 'init'"
                      label="帳號"
                      type="text"
                      dense
                      class="font-weight-normal"
                      disabled
                      v-model="member.account"
                    ></v-text-field>
                  </v-col>

                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password"
                        label="密碼"
                        :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                        :type="showPassword1 ? 'text' : 'password'"
                        @click:append="showPassword1 = !showPassword1"
                        v-model="pw"
                        clearable
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password2"
                        label="確認密碼"
                        :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                        :type="showPassword2 ? 'text' : 'password'"
                        @click:append="showPassword2 = !showPassword2"
                        v-model="pw2"
                        clearable
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-label>
                        <p class="font-weight-normal">綁定社群帳號</p>
                      </v-label>
                      <v-spacer />
                      <v-btn class="mr-2" >Facebook 帳號</v-btn>
                      <v-btn class="mr-2" >Google 帳號</v-btn>
                    </v-col>
                    <v-col cols="12" md="8"></v-col>
                    <v-col cols="12" md="8"></v-col>
                  </v-row>
                  <v-col cols="12" md="8">
                    <h2>通譯人員基本資料</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="姓名"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-radio-group
                        v-model="member.gender"
                        label="性別"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      >
                        <v-radio label="男" value="M" dense color="red"></v-radio>
                        <v-radio label="女" value="F" dense color="red"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="統一證號或身分證字號"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.idNo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="member.birthday"
                            label="出生日期"
                            readonly
                            v-on="on"
                            dense
                            class="font-weight-normal"
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
                          v-model="member.birthday"
                          @input="menu1 = false"
                          locale="zh-cn"
                          style="font-family:Microsoft JhengHei;"
                          color="red"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        v-model="member.nationality"
                        :items="getCodeDateUtil('nation')"
                        label="原屬國籍"
                        dense
                        style="font-family:Microsoft JhengHei;"
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-select
                        v-model="member.educationLevel"
                        :items="getCodeDateUtil('eduLevel')"
                        label="教育程度"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-select
                        v-model="member.currentJob"
                        :items="getCodeDateUtil('jobType')"
                        label="現職"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-radio-group
                        v-model="member.qualificationInTaiwan"
                        label="在臺資格與取得證件"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      >
                        <v-radio label="持中華民國身分證" value="持中華民國身分證" dense color="red"></v-radio>
                        <v-radio label="持有效之中華民國居留證" value="持有效之中華民國居留證" dense color="red"></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray1"
                        item-text="name"
                        item-value="id"
                        v-model="member.city"
                        @change="districtObjectUtil(member.city);"
                        label="聯絡縣市"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray2"
                        item-text="name"
                        item-value="id"
                        label="聯絡地區"
                        dense
                        class="font-weight-normal"
                        v-model="member.district"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="聯絡地址"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactAddress"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactHomeTel"
                        label="住家電話"
                        type="text"
                        :rules="contactHomeTelRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactHomeTel"
                        @change="checkContactHomeTel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactMobileTel"
                        label="行動電話"
                        type="text"
                        :rules="contactMobileTelRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactMobileTel"
                        @change="checkContactMobileTel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="電子信箱"
                        type="text"
                        :rules="emailRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-textarea
                        label="個人註記及通譯服務經歷"
                        type="text"
                        clearable
                        dense
                        rows="3"
                        counter
                        maxlength="200"
                        class="font-weight-normal"
                        v-model="member.note"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="8">
                    <h2>通譯服務資訊</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="member.serviceStartDate"
                            label="開始從事通譯服務時間"
                            readonly
                            v-on="on"
                            dense
                            class="font-weight-normal"
                            :rules="requiredRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
                          v-model="member.serviceStartDate"
                          @input="menu2 = false"
                          locale="zh-cn"
                          style="font-family:Microsoft JhengHei;"
                          color="red"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        item-color="red"
                        v-model="serviceType"
                        :items="getCodeDateUtil('serveType')"
                        dense
                        chips
                        small-chips
                        label="服務類型(可複選)"
                        multiple
                        class="font-weight-normal"
                        :rules="selectRequiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-autocomplete
                        item-color="red"
                        v-model="serviceLanguage"
                        :items="getCodeDateUtil('lang')"
                        dense
                        chips
                        small-chips
                        label="熟悉語言(可複選)"
                        multiple
                        class="font-weight-normal"
                        :rules="selectRequiredRules"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-label class="font-weight-normal">
                        <p class="font-weight-normal">可服務地區 (可複選)</p>
                      </v-label>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn
                        color="red"
                        dark
                        @click="dialogDistrict = !dialogDistrict;areaFlag = true"
                        class="font-weight-normal"
                      >增加地區</v-btn>
                    </v-col>
                    <v-col cols="12" md="10">
                      <div
                        v-show="selectItem.length==0 && areaFlag && !dialogDistrict"
                        class="v-text-field__details"
                      >
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              <B>此欄位是必填</B>
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-scroll-x-transition group hide-on-leave>
                        <v-chip
                          v-for="(selection, i) in selectItem"
                          :key="i"
                          color="grey"
                          dark
                          small
                          class="ma-1 font-weight-normal"
                        >
                          <v-icon left small @click="selectItem.splice(i,1)">mdi-window-close</v-icon>
                          {{ selection }}
                        </v-chip>
                      </v-scroll-x-transition>
                      <div v-if="dialogDistrict">
                        <v-dialog v-model="dialogDistrict" width="250px">
                          <DistrictComponents
                            :selectItem="selectItem"
                            v-on:childDialog="parentDialog"
                            v-on:update-text="getChildText"
                          ></DistrictComponents>
                        </v-dialog>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-label>
                        <p class="font-weight-normal">
                          <br />可服務時間
                          (可複選)
                        </p>
                        <div
                          v-show="serviceTime.length==0 && serviceTimeFlag "
                          class="v-text-field__details"
                        >
                          <div class="v-messages theme--light error--text" role="alert">
                            <div class="v-messages__wrapper">
                              <div class="v-messages__message">
                                <B>此欄位是必填</B>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-label>
                    </v-col>
                    <v-col cols="12" md="12" sm="8">
                      <v-simple-table>
                      <thead>
                        <tr>
                        <th class="text-center"></th>
                        <th class="text-center"><v-label>早上 06:00-12:00</v-label></th>
                        <th class="text-center"><v-label>中午 12:00-18:00</v-label></th>
                        <th class="text-center"><v-label>晚上 18:00-24:00</v-label></th>
                        <th class="text-center"><v-label>午夜 00:00-06:00</v-label></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td class="text-center">一</td>
                        <td><v-checkbox v-model="serviceTime" value="a1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">二</td>
                        <td><v-checkbox v-model="serviceTime" value="b1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">三</td>
                        <td><v-checkbox v-model="serviceTime" value="c1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">四</td>
                        <td><v-checkbox v-model="serviceTime" value="d1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">五</td>
                        <td><v-checkbox v-model="serviceTime" value="e1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">六</td>
                        <td><v-checkbox v-model="serviceTime" value="f1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">日</td>
                        <td><v-checkbox v-model="serviceTime" value="g1" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g2" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g3" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g4" hide-details color="red" class="align-center justify-center"></v-checkbox></td>
                        </tr>
                      </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                


                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                            <v-label>
                              <p class="font-weight-normal">資格認證證書或培訓通過名冊</p>
                           </v-label>
                              <vue-dropzone
                                ref="myVueDropzonePic"
                                id="dropzonePic"
                                :options="dropzonePicOptions"
                                @vdropzone-success="successUploadPic"
                                @vdropzone-removed-file="removedPic" >
                                </vue-dropzone>
                              <v-btn color="blue darken-1" text @click="removeAllObjects('CER')">移除所有圖片</v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                            <v-label>
                              <p class="font-weight-normal">中華民國身分證或居留證件</p>
                           </v-label>
                              <vue-dropzone
                                ref="myVueDropzoneFile"
                                id="dropzoneFile"
                                :options="dropzonePicOptions"
                                @vdropzone-success="successUploadFile"
                                @vdropzone-removed-file="removedFile" >
                                </vue-dropzone>
                              <v-btn color="blue darken-1" text @click="removeAllObjects('IDC')">移除所有圖片</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" >
                      <v-select multiple :rules="selectRequiredRules" item-text="text" item-value="value" :items="ugrpGroup" label="權限群組" dense class="font-weight-normal" v-model="ugrpIdArray" > </v-select>
                    </v-col>
                  </v-row>                  
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-btn color="red" style="color:white;"
                      :disabled="(!valid) || serviceTime.length==0 || selectItem.length==0"  @click="savedata">儲存</v-btn>
                    </v-col>
                  </v-row>
                  

    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import DistrictComponents from "../Common/DistrictComponents";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import "vue-wysiwyg/dist/vueWysiwyg.css";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
      DistrictComponents,
       vueDropzone: vue2Dropzone
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      menu1: false,
      menu2: false,

      ac: null,
      pw: null,
      pw2: null,
      row1: null,
      
      showPassword1: false,
      showPassword2: false,
      accountExists: false,
      txtAccountExists: "",
      ugrpGroup: [ {text: "通譯人員", value: "interpreter_role_id"} ],
      formHasErrors: false,
      nameRules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        //  特殊符號 (?=.*[^a-zA-Z0-9])
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      pw2Rules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一",
        v => v === this.pw || "和密碼不相符"
      ],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      emailRules: [
        v => !!v || "此欄位是必填",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "電子信箱格式有誤!"
      ],
      contactHomeTelRules: [
        v =>
          (v && v.length > 0) ||
          this.member.contactMobileTel.length > 0 ||
          "住家電話或行動電話請二擇一選填"
      ],
      contactMobileTelRules: [
        v =>
          (v && v.length > 0) ||
          this.member.contactHomeTel.length > 0 ||
          "住家電話或行動電話請二擇一選填"
      ],
      
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),

      dialogDistrict: false,
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      registerToken: null,
      serviceTime: [],
      selectItem: [],
      serviceType: [],
      serviceLanguage: [],
      attachDataPhoto: [],
      attachDataFile: [],
      areaFlag: false,
      serviceTimeFlag: false,
      editedIndex: -1,
      member: this.getModel("motorAccount"),
      dropzonePicOptions: {
        url: 'http://146.71.77.32:8080/idb/uploadFile',
        maxFilesize: 5,  // MB
        maxFiles: 10,
        filesizeBase: 1024,
        addRemoveLinks: true,
        thumbnailWidth: 150,
        // chunking: true,
        // chunkSize: 500, // Bytes
        // uploadMultiple: true,
        // parallelUploads: 3,
        autoProcessQueue: true,
        acceptedFiles: '.jpg, .jpeg, .png, .gif, .bmp,  .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .zip',
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>請點擊或拖曳圖片上傳<br/>圖片請勿超過5MB<br/>最多上傳10個圖片",
        dictRemoveFile: "刪除圖片",
        dictFileTooBig: "檔案太大",
        dictInvalidFileType: "不允許的檔案格式",
        dictMaxFilesExceeded: "檔案數量超過限制",
        dictCancelUploadConfirmation: "是否確定要取消上傳",
        headers: { "Authorization": this.$localStorage.get("idb_login_token") },
        init: function() {
          // var self = this;
          // self.on("uploadprogress", function(file, progress) {
          //   console.log("File progress", progress);
          // });
          // self.removeAllFiles();
        }
      },
      ugrpIdArray: [],
      finalObject: [],
      
      dialog: false,
      valid: false,

      items: [],
      
      memberUuid:"",
      memberType:"",
    };
  },
  watch: {
    options: {
      handler() {
       this.getInterpreterFromServer()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    parentDialog() {
      this.dialogDistrict = false;
    },
    checkContactHomeTel() {
      let vm = this;
      if (vm.member.contactMobileTel == "") {
        vm.member.contactMobileTel = " ";
        setTimeout(function() {
          vm.member.contactMobileTel = "";
        }, 100);
      }
    },
    checkContactMobileTel() {
      let vm = this;
      if (vm.member.contactHomeTel == "") {
        vm.member.contactHomeTel = " ";
        setTimeout(function() {
          vm.member.contactHomeTel = "";
        }, 100);
      }
    },
    getChildText: function(value) {
      this.selectItem = value;
    },
    deleteFile(filename){
      var vm=this;
      vm.axios
        .delete(vm.idbServerUrl + "idb/deleteFile/"+filename, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          console.log("delete tmp file ---->\n" + JSON.stringify(response));
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    removedPic(file, error, xhr) {
      //console.log("removedPic is ->", file.upload.uuid);
      //console.log("removedPic is ->", JSON.stringify(file));
      //console.log("file start is ->", JSON.stringify(file));
      console.log("error is ->", JSON.stringify(error));
      console.log("xhr is ->", JSON.stringify(xhr));
      this.attachDataPhoto.forEach((element, index) => {
        if(file.upload) {
          if (file.upload.uuid == element.uuid) {
            this.deleteFile(element.newAttachName)
            this.attachDataPhoto.splice(index,1)
          }
        } else {
          if (file.name == element.newAttachName) {
            this.attachDataPhoto.splice(index,1)
          }
        }
      });
      //console.log("attachDataPhoto end is ->", JSON.stringify(this.attachDataPhoto));
    },
    removedFile(file, error, xhr) {
      console.log("error is ->", JSON.stringify(error));
      console.log("xhr is ->", JSON.stringify(xhr));
      this.attachDataFile.forEach((element, index) => {
        if(file.upload) {
          if (file.upload.uuid == element.uuid) {
            this.deleteFile(element.newAttachName)
            this.attachDataFile.splice(index,1)
          }
        } else {
          if (file.name == element.newAttachName) {
            this.attachDataFile.splice(index,1)
          }
        }
      });
    },
    successUploadPic(file, response) {
      var attachFile={}
      response.type = "CER"  //ATT, IMG, DWN
      //console.log("File uploaded successfully");
      //console.log("Response is ->", response);
      attachFile.uuid = file.upload.uuid
      attachFile.attachName = response.fileName
      attachFile.attachPath = "idb/downloadFile/"+ response.newFileName.toLowerCase() +"/CER"
      attachFile.description = response.fileName
      attachFile.newAttachName = response.newFileName.toLowerCase()
      attachFile.priority = file.upload.total   // record pic size
      attachFile.title = response.fileName
      attachFile.type = "CER"
      this.attachDataPhoto.push(attachFile)
      //console.log("attachDataPhoto is ->", JSON.stringify(this.attachDataPhoto));
    },
    successUploadFile(file, response) {
      var attachFile={}
      response.type = "IDC"  //ATT, IMG, DWN
      attachFile.uuid = file.upload.uuid
      attachFile.attachName = response.fileName
      attachFile.attachPath = "idb/downloadFile/"+ response.newFileName.toLowerCase() +"/IDC"
      attachFile.description = response.fileName
      attachFile.newAttachName = response.newFileName.toLowerCase()
      attachFile.priority = file.upload.total     // record pic size
      attachFile.title = response.fileName
      attachFile.type = "IDC"
      this.attachDataFile.push(attachFile)
    },
    removeAllObjects(act) {
      if (act == "CER") {
        this.$refs.myVueDropzonePic.removeAllFiles();
        this.attachDataPhoto = []
      } else if (act=="IDC") {
        this.$refs.myVueDropzoneFile.removeAllFiles();
        this.attachDataFile = []
      }
    },
    processAttachSet(act) {
      var attachFile = {};
      var mockFile = {};
      var i = 0;
      this.member.type='1'
      if ( act == "CER") {
        for (i = 0; i < this.member.memberAccountCertificateSet.length; i++) {
          attachFile = {}
          mockFile = {}
          attachFile.attachId = this.member.memberAccountCertificateSet[i].attachId
          attachFile.uuid = this.member.memberAccountCertificateSet[i].attachId
          attachFile.attachName = this.member.memberAccountCertificateSet[i].attachName
          attachFile.attachPath = this.member.memberAccountCertificateSet[i].attachPath
          attachFile.description = this.member.memberAccountCertificateSet[i].description
          attachFile.newAttachName = this.member.memberAccountCertificateSet[i].newAttachName
          attachFile.priority = this.member.memberAccountCertificateSet[i].priority
          attachFile.title = this.member.memberAccountCertificateSet[i].attachName
          attachFile.type = this.member.memberAccountCertificateSet[i].type
          mockFile.name = this.member.memberAccountCertificateSet[i].newAttachName
          mockFile.size = this.member.memberAccountCertificateSet[i].priority
          this.attachDataPhoto.push(attachFile)

          this.$refs.myVueDropzonePic.manuallyAddFile(mockFile, this.idbServerUrl + this.member.memberAccountCertificateSet[i].attachPath)
          console.log( this.idbServerUrl + this.member.memberAccountCertificateSet[i].attachPath)
        }
      } else if ( act == "IDC") {
        for (i = 0; i < this.member.memberAccountIdentifySet.length; i++) {
          attachFile = {}
          mockFile = {}
          attachFile.attachId = this.member.memberAccountIdentifySet[i].attachId
          attachFile.uuid = this.member.memberAccountIdentifySet[i].attachId
          attachFile.attachName = this.member.memberAccountIdentifySet[i].attachName
          attachFile.attachPath = this.member.memberAccountIdentifySet[i].attachPath
          attachFile.description = this.member.memberAccountIdentifySet[i].description
          attachFile.newAttachName = this.member.memberAccountIdentifySet[i].newAttachName
          attachFile.priority = this.member.memberAccountIdentifySet[i].priority
          attachFile.title = this.member.memberAccountIdentifySet[i].attachName
          attachFile.type = this.member.memberAccountIdentifySet[i].type
          mockFile.name = this.member.memberAccountIdentifySet[i].newAttachName
          mockFile.size = this.member.memberAccountIdentifySet[i].priority
          this.attachDataFile.push(attachFile)
          this.$refs.myVueDropzoneFile.manuallyAddFile(mockFile, this.idbServerUrl + this.member.memberAccountIdentifySet[i].attachPath)
        }
      }
    },
    checkExistingFiles () {
      this.removeAllObjects("CER")
      this.processAttachSet("CER")
      this.removeAllObjects("IDC")
      this.processAttachSet("IDC")
    },
    
    savedata () {
        var vm = this;
        var languageStr1 ="";
        if(this.serviceLanguage !=null){
          for(let a=0;a<this.serviceLanguage.length;a++){
                  languageStr1 += this.serviceLanguage[a]+",";
          }
          languageStr1  = languageStr1.substring(0, languageStr1.length-1);
          vm.member.serviceLanguage = languageStr1;
        }
        var itemStr1 ="";
        if(this.selectItem !=null){
          for(let a=0;a<this.selectItem.length;a++){
                  itemStr1 += this.selectItem[a]+",";
          }
          itemStr1  = itemStr1.substring(0, itemStr1.length-1);
          vm.member.serviceCity = itemStr1;
        }
        var timeStr1 ="";
        if(this.serviceTime !=null){
          for(let a=0;a<this.serviceTime.length;a++){
                  timeStr1+= this.serviceTime[a]+",";
          }
          timeStr1  = timeStr1.substring(0, timeStr1.length-1);
          vm.member.serviceTime = timeStr1;
        }
        var typeStr1 ="";
        if(this.serviceType !=null){
          for(let a=0;a<this.serviceType.length;a++){
                  typeStr1 += this.serviceType[a]+",";
          }
          typeStr1  = typeStr1.substring(0, typeStr1.length-1);
          vm.member.serviceType = typeStr1;
        }

        vm.finalObject=[];
        var objTmpUgrp1={};
        if (vm.ugrpIdArray != null && vm.ugrpIdArray.length != 0) {
          for (var i1 = 0; i1 < vm.ugrpIdArray.length; i1++) {
            objTmpUgrp1 = {
              roleId: vm.ugrpIdArray[i1],
              targetId: vm.memberUuid
            };
            vm.finalObject.push(objTmpUgrp1);
          }
        }
        vm.member.type = "CCC";
        if ( vm.pw != "" && vm.pw === vm.pw2 && vm.pw != "originalPW99") {
          vm.member.password = vm.pw;
        }
        vm.member.mainDeptId = vm.userProfile.memberAccount.mainDeptId;
        vm.member.mainDeptName = vm.userProfile.memberAccount.mainDeptName;
        var data1 = {
            authRoleTargetList:vm.finalObject,
            memberAccount:vm.member,
            identifyCardList: vm.attachDataFile,
            certificateList: vm.attachDataPhoto
        };

        if (vm.$route.params.uuid == "init") {
            vm.axios
              .post(vm.idbServerUrl + "idb/member/memberAccount", data1, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: vm.$localStorage.get("idb_login_token")
                }
              })
              .then(function(response) {
                console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                vm.$router.push({
                  path: "/ListInterpreterList"
                });
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                //console.log(error);
              });
        }else{
            vm.axios
              .put(vm.idbServerUrl + "idb/member/memberAccount", data1, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: vm.$localStorage.get("idb_login_token")
                }
              })
              .then(function(response) {
                console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                vm.$router.push({
                  path: "/ListInterpreterList"
                });
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                //console.log(error);
              });
         }
    },

    checkAccount() {
      var vm = this;
      if (vm.member.account.length>5)
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/isAccountExist/" + vm.member.account,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          //console.log("response" + JSON.stringify(response.data));
          vm.accountExists=false;
          vm.txtAccountExists="";
          if (response.data.exist) {
            vm.accountExists=true;
            vm.txtAccountExists = "帳號重複，請重新設定";
          }
          console.log("accountExists  " + vm.accountExists);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    },
    getInterpreterFromServer() {
      var vm = this;
      if (vm.$route.params.uuid != "init") {
        vm.axios
          .get(
            vm.idbServerUrl +
              "idb/member/memberAccount/"+this.$route.params.uuid,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            }
          )
          .then(function(response) {
            //console.log("resultList??" + JSON.stringify(response.data.resultList));

            vm.pw = "originalPW99";
            vm.pw2 = "originalPW99";
            vm.member = response.data;
            vm.memberUuid = vm.member.uuid;
            vm.memberType = vm.member.type;

            var newDateStr = ""
            var typeAll = [];
            var languageAll = [];
            var cityAll = [];
            var timeAll = [];
            vm.serviceType = [];
            vm.serviceLanguage = [];
            vm.selectItem = [];
            vm.serviceTime = [];
              
            if (vm.member.serviceStartDate != null) {
              newDateStr = vm.convertJsonDate(
                vm.member.serviceStartDate,
                ""
              );
              vm.member.serviceStartDate = newDateStr;
            }
            if (vm.member.birthday != null) {
              newDateStr = vm.convertJsonDate(
                vm.member.birthday,
                ""
              );
              vm.member.birthday = newDateStr;
            }
            if (vm.member.createDate != null) {
              newDateStr = vm.convertJsonDate(
                vm.member.createDate,
                ""
              );
              vm.member.createDate = newDateStr;
            }
            if(vm.member.serviceType !=null){
              typeAll =  vm.member.serviceType.split(",")
              for(let b=0;b<typeAll.length;b++){
                vm.serviceType.push(typeAll[b]);
              }
            }
            if(vm.member.serviceLanguage !=null){
              languageAll =  vm.member.serviceLanguage.split(",")
              for(let b=0;b<languageAll.length;b++){
                vm.serviceLanguage.push(languageAll[b]);
              }
            }
            if(vm.member.serviceCity !=null){
              cityAll =  vm.member.serviceCity.split(",")
              for(let b=0;b<cityAll.length;b++){
                vm.selectItem.push(cityAll[b]);
              }
            }
            if(vm.member.serviceTime !=null){
              timeAll =  vm.member.serviceTime.split(",")
              for(let b=0;b<timeAll.length;b++){
                vm.serviceTime.push(timeAll[b]);
              }
            }
            vm.districtObjectUtil(vm.member.city);

            vm.checkExistingFiles();

            vm.ugrpIdArray = [];
            vm.axios
              .get(
                vm.idbServerUrl + "idb/auth/AuthRoleTarget/" +
                  vm.memberUuid,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                vm.items2 = response.data.resultList
                for (var i = 0; i < vm.items2.length; i++) {
                    vm.ugrpIdArray.push(vm.items2[i].roleId);
                }
                vm.checkContactHomeTel();
                vm.checkContactMobileTel();
                
              })
              .catch(function(error) {
                vm.handErrorUtil(error.response.status);
              });
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
          });
      }
      //this.$refs.form.validate();
    }
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
    //this.$refs.form.validate();
    //console.log("!!!!!!!!!! " + this.$refs.form.validate());
  }
};
</script>




